<div class="captcha">
  <label class="captcha__label">{{ 'captcha_label' | translate }} <span class="captcha__req">*</span></label>
  <div class="captcha__row">
    <div class="captcha__image" [innerHTML]="svg" [class.captcha__image--loading]="loading"></div>
    <button type="button" class="captcha__refresh" (click)="refresh()" [title]="'captcha_refresh' | translate" [attr.aria-label]="'captcha_refresh' | translate">
      <i class="icofont-refresh"></i>
    </button>
    <input
      type="text"
      class="captcha__input"
      [value]="value"
      (input)="onInput($any($event.target).value)"
      [placeholder]="'captcha_placeholder' | translate"
      autocomplete="off"
      spellcheck="false"
      maxlength="6"
      inputmode="text" />
  </div>
  <span class="captcha__hint">{{ 'captcha_hint' | translate }}</span>
</div>
